import { combineReducers } from 'redux';

import { isNewReducer } from './isNew';
import { notifListReducer } from './notifList';
import { notifReadStatusMapReducer } from './notifReadStatusMap';

export const reducersRaw = {
  notifications: combineReducers({
    isNew: isNewReducer,
    notifList: notifListReducer,
    notifReadStatusMap: notifReadStatusMapReducer,
  }),
};
